export default "__VITE_ASSET__DwAGtpNs__"